import { VIDEO_SKIP_SECONDS } from "constants/streaming";

import Player from "video.js/dist/types/player";
import { getVideoJsComponent } from "./utils";

/**
 * HACK: theoplayerの読み込みが完了する前にこのモジュールがインポートされると、
 * getVideoJsComponent内でwindow.THEOplayerがundefinedとなりエラーになるため、
 * 関数としてエクスポートし、必要なときに呼び出す形にする。
 * 本当はnpm管理のtheoplayerパッケージを使いたいが、検証が不十分なため現状はこの方法で対応。
 */
export const getRewindButton = () => {
  const VideoJSButton = getVideoJsComponent("Button");

  class RewindButton extends VideoJSButton {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    handleClick() {
      const currentTime = this.player().currentTime();
      if (currentTime !== undefined)
        this.player().currentTime(currentTime - VIDEO_SKIP_SECONDS);
    }

    createEl() {
      const backwardIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
<g clip-path="url(#clip0_1763_1354)">
<path d="M12.9898 5.64998V1.44998L7.73984 6.69998L12.9898 11.95V7.74998C16.4653 7.74998 19.2898 10.5745 19.2898 14.05C19.2898 17.5255 16.4653 20.35 12.9898 20.35C9.51434 20.35 6.68984 17.5255 6.68984 14.05H4.58984C4.58984 18.691 8.34884 22.45 12.9898 22.45C17.6308 22.45 21.3898 18.691 21.3898 14.05C21.3898 9.40898 17.6308 5.64998 12.9898 5.64998Z" fill="white"/>
<path d="M11.8358 17.2H10.9433V13.777L9.88281 14.1025V13.378L11.7413 12.7165H11.8358V17.2ZM16.3298 15.352C16.3298 15.688 16.2983 15.982 16.2248 16.213C16.1513 16.444 16.0463 16.654 15.9203 16.8115C15.7943 16.969 15.6263 17.0845 15.4478 17.158C15.2693 17.2315 15.0593 17.263 14.8283 17.263C14.5973 17.263 14.3978 17.2315 14.2088 17.158C14.0198 17.0845 13.8623 16.969 13.7258 16.8115C13.5893 16.654 13.4843 16.4545 13.4108 16.213C13.3373 15.9715 13.2953 15.688 13.2953 15.352V14.575C13.2953 14.239 13.3268 13.945 13.4003 13.714C13.4738 13.483 13.5788 13.273 13.7048 13.1155C13.8308 12.958 13.9988 12.8425 14.1773 12.769C14.3558 12.6955 14.5658 12.664 14.7968 12.664C15.0278 12.664 15.2273 12.6955 15.4163 12.769C15.6053 12.8425 15.7628 12.958 15.8993 13.1155C16.0358 13.273 16.1408 13.4725 16.2143 13.714C16.2878 13.9555 16.3298 14.239 16.3298 14.575V15.352ZM15.4373 14.449C15.4373 14.2495 15.4268 14.0815 15.3953 13.945C15.3638 13.8085 15.3218 13.7035 15.2693 13.6195C15.2168 13.5355 15.1538 13.4725 15.0698 13.441C14.9858 13.4095 14.9018 13.3885 14.8073 13.3885C14.7128 13.3885 14.6183 13.4095 14.5448 13.441C14.4713 13.4725 14.3978 13.5355 14.3453 13.6195C14.2928 13.7035 14.2508 13.8085 14.2193 13.945C14.1878 14.0815 14.1773 14.2495 14.1773 14.449V15.4675C14.1773 15.667 14.1878 15.835 14.2193 15.9715C14.2508 16.108 14.2928 16.2235 14.3453 16.3075C14.3978 16.3915 14.4608 16.4545 14.5448 16.486C14.6288 16.5175 14.7128 16.5385 14.8073 16.5385C14.9018 16.5385 14.9963 16.5175 15.0698 16.486C15.1433 16.4545 15.2168 16.3915 15.2693 16.3075C15.3218 16.2235 15.3638 16.108 15.3848 15.9715C15.4058 15.835 15.4268 15.667 15.4268 15.4675V14.449H15.4373Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_1763_1354">
<rect width="25.2" height="25.2" fill="white" transform="translate(0.400391 0.399994)"/>
</clipPath>
</defs>
</svg>
    `;

      const el = super.createEl("button", {
        className:
          "vjs-custom-rewind-button vjs-custom-button vjs-control vjs-button",
        innerHTML: `
      ${backwardIcon}
        <span class="vjs-control-text">Back 10 seconds</span>
      `,
        title: "Back 10 seconds",
      });
      return el;
    }
  }

  return RewindButton;
};

/**
 * HACK: theoplayerの読み込みが完了する前にこのモジュールがインポートされると、
 * getVideoJsComponent内でwindow.THEOplayerがundefinedとなりエラーになるため、
 * 関数としてエクスポートし、必要なときに呼び出す形にする。
 * 本当はnpm管理のtheoplayerパッケージを使いたいが、検証が不十分なため現状はこの方法で対応。
 */
export const getForwardButton = () => {
  const VideoJSButton = getVideoJsComponent("Button");

  class ForwardButton extends VideoJSButton {
    constructor(player: Player, options = {}) {
      super(player, options);
    }
    handleClick() {
      const currentTime = this.player().currentTime();
      if (currentTime !== undefined) {
        this.player().currentTime(currentTime + VIDEO_SKIP_SECONDS);
      }
    }

    createEl() {
      const forwardIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
  <g clip-path="url(#clip0_1763_1361)">
    <path d="M19.2996 14.05C19.2996 17.5255 16.4751 20.35 12.9996 20.35C9.52411 20.35 6.69961 17.5255 6.69961 14.05C6.69961 10.5745 9.52411 7.74998 12.9996 7.74998V11.95L18.2496 6.69998L12.9996 1.44998V5.64998C8.35861 5.64998 4.59961 9.40898 4.59961 14.05C4.59961 18.691 8.35861 22.45 12.9996 22.45C17.6406 22.45 21.3996 18.691 21.3996 14.05H19.2996Z" fill="white"/>
    <path d="M11.8026 17.137V12.6535H11.7081L9.84961 13.315V14.0395L10.9101 13.714V17.137H11.8026ZM13.2621 14.512V15.289C13.2621 17.284 14.6376 17.2 14.7741 17.2C14.9211 17.2 16.2861 17.2945 16.2861 15.289V14.512C16.2861 12.517 14.9106 12.601 14.7741 12.601C14.6271 12.601 13.2621 12.5065 13.2621 14.512ZM15.4041 14.386V15.4045C15.4041 16.213 15.1836 16.486 14.7846 16.486C14.3856 16.486 14.1546 16.213 14.1546 15.4045V14.386C14.1546 13.5985 14.3856 13.3255 14.7741 13.3255C15.1731 13.315 15.4041 13.5985 15.4041 14.386Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_1763_1361">
      <rect width="25.2" height="25.2" fill="white" transform="translate(0.400391 0.399994)"/>
    </clipPath>
  </defs>
</svg>`;

      const el = super.createEl("button", {
        className:
          "vjs-custom-forward-button vjs-custom-button vjs-control vjs-button",
        innerHTML: `
      ${forwardIcon}
        <span class="vjs-control-text">Forward 10 seconds</span>
      `,
        title: "Forward 10 seconds",
      });
      return el;
    }
  }

  return ForwardButton;
};
